import { useLocation } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import { Stack } from '@mui/material';

import { MEDIA_TYPE } from '../../constants/mediaData';

import img_noData from '../../assets/images/img_noData.svg';
import img_noData_facebook from '../../assets/images/img_noData_facebook.svg';
import img_noData_google from '../../assets/images/img_noData_google.svg';
import img_noData_line from '../../assets/images/img_noData_line.svg';
import img_noData_taboola from '../../assets/images/img_noData_taboola.svg';

import img_filterNoData from '../../assets/images/img_filterNoData.svg';
import img_filterNoData_facebook from '../../assets/images/img_filterNoData_facebook.svg';
import img_filterNoData_google from '../../assets/images/img_filterNoData_google.svg';
import img_filterNoData_line from '../../assets/images/img_filterNoData_line.svg';
import img_filterNoData_taboola from '../../assets/images/img_filterNoData_taboola.svg';

import { handleColorSystem } from '../customComponent/colorSystem';
import theme from '../../theme';

const ImgBlock = styled('img')(({ theme }) => ({
  maxWidth: '400px',
  marginBottom: '24px'
}))

const imageSources = {
  noData: {
    default: img_noData,
    FACEBOOK: img_noData_facebook,
    GOOGLE: img_noData_google,
    LINE: img_noData_line,
    TABOOLA: img_noData_taboola,
  },
  filterNoData: {
    default: img_filterNoData,
    FACEBOOK: img_filterNoData_facebook,
    GOOGLE: img_filterNoData_google,
    LINE: img_filterNoData_line,
    TABOOLA: img_filterNoData_taboola,
  }
}

const NoData = ({ searchKeyword, media, children }) => {
  const { pathname, state } = useLocation();
  const { mainColor } = handleColorSystem(media);

  const getImageSource = (type) => {
    return imageSources[type][media] || imageSources[type].default;
  }

  if (searchKeyword !== '' && searchKeyword) {
    return (
      <Box
        sx={{
          width: '100%',
          padding: '64px 0',
          textAlign: 'center',
        }}
      >
        <ImgBlock src={getImageSource('filterNoData')} alt="沒有符合條件的資料" />
        
        <Typography align="center">
          <FormattedMessage
            id="common.search.noData"
            values={{
              keyword: <span style={{ color: mainColor }}>{searchKeyword}</span>,
              br: <br />,
            }}
          />
        </Typography>
      </Box>
    )
  }

  return (
    <>
      {
        <Box
          sx={{
            width: '100%',
            padding: '42px 0',
            textAlign: 'center',
          }}
        >
          <ImgBlock src={getImageSource('noData')} alt="無資料" />
          {
            children
              ? children
              : <Typography>無資料</Typography>
          }
        </Box>
      }
    </>
  );
};

export default NoData;